<template>
<div class="card">
  <div class="card-header">
    <h5>Configurações de Lâmpadas</h5>
  </div>
  <div class="card-content">
    <div class="form-group">
      <label>Quantidade de lâmpadas</label>
      <input
        type="number"
        min="0"
        name="numberOfLamps"
        v-validate="modelValidations.numberOfLamps"
        v-model="event.numberOfLamps"
        class="form-control"
      />
      <small
        class="text-danger"
        v-show="numberOfLamps.invalid"
      >{{ errors.first('numberOfLamps') }}
      </small>
    </div>
    <div class="form-group">
      <label for="form-event-power-label">Qual será a potência da lâmpada a ser entregue?</label>
      <input
        type="text"
        id="form-event-power-label"
        v-model="event.lamp.powerLampDeliveryLabel"
        class="form-control"
      >
      <small>OBS: Não inserir o <strong>W</strong> da potência</small>
    </div>
    <div class="form-group">
      <label for="form-event-power-label">Será obrigatório o tempo de lâmpadas no ato da troca?</label>
      <YesNoRadio v-model="event.lamp.requiredTermLamp"/>
      <small>Somente será possível trocar lâmpada se enviar o termo</small>
    </div>
  </div>
</div>
</template>

<script>
import YesNoRadio from '../YesNoRadio'
import { mapGetters } from 'vuex'
import { mapFields } from 'vee-validate'

export default {
  name: 'LampEventConfigFormConmponent',
  components: {
    YesNoRadio
  },
  computed: {
    ...mapGetters('events', { modelValidations: 'validations' }),
    ...mapFields(['numberOfLamps']),
    event: {
      get () {
        return this.$store.state.events.one
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Event/LampEventConfigFormConmponent.vue